import { render, staticRenderFns } from "./PaperWalletToPrint.vue?vue&type=template&id=143e0b35"
import script from "./PaperWalletToPrint.vue?vue&type=script&lang=js"
export * from "./PaperWalletToPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports